import { call, put, select, takeLatest } from 'redux-saga/effects';

import API from 'services/api';

import { fetchProfile } from 'store/session/actions';
import { getGroupId } from 'store/session/selectors';

import { types, updateSupplierDefaultInternalNotes } from './actions';

export default function* root() {
  yield takeLatest(
    types.UPDATE_SUPPLIER_INTERNAL_QUOTE_NOTES_REQUEST,
    watchUpdateSupplierInternalNotes,
  );
}

function* watchUpdateSupplierInternalNotes(action) {
  try {
    const groupId = yield select(getGroupId);
    const { internalNotes } = action.payload;
    const result = yield call(
      API.supplier.updateSupplierInternalNotes,
      groupId,
      {
        defaultInternalQuoteNotes: internalNotes,
      },
    );
    if (result) {
      yield put(
        updateSupplierDefaultInternalNotes.success({
          internalNotes: result.defaultInternalQuoteNotes,
        }),
      );
    }
    // reload the users profile to include updated internal notes
    yield put(fetchProfile.request());
  } catch (error) {
    yield put(updateSupplierDefaultInternalNotes.error(error));
  }
}
